<template>
	<div></div>
</template>

<script>
export default {
	props: ['data'],
	data() {
		return {
			blockClasses: 'color-mode-breakpoint animateable-block',
			blockGridClasses: 'row small-up-1 medium-up-2',
			active: false,
			animate: false,
			backgroundShade: 'dark',
			headerLinkOffset: 0,
			scrollOffset: 0
		}
	},
	methods: {
		updateHeaderLinkOffset() {
			var element = document.querySelector('.header-link-wrapper');
			if (typeof element === 'undefined' || element === null) return false;
			this.headerLinkOffset = element.offsetTop
		},
		getHeaderTopOffset() {
			if (typeof this.headerLinkOffset==='undefined') {
				setTimeout(() => { this.updateHeaderLinkOffset() }, 500);
				return;
			}
			//return this.headerLinkOffset;
			return window.innerHeight - this.headerLinkOffset;
		},
		handleScroll () {
			//if (typeof this.data.featured_page_left === 'undefined' || this.data.featured_page_left.title!=="Responsive Tabs Test") return;

			var direction = (this.scrollOffset > window.pageYOffset) ? 'up' : 'down';
			this.scrollOffset = window.pageYOffset;

			var topSwitchOffset = this.getHeaderTopOffset();
			var offsetTopPosition = this.$el.offsetTop - window.pageYOffset;
			var offsetTop = Math.abs(offsetTopPosition);

			if (typeof this.$refs.animationWrapper !== 'undefined') {
				// This triggers the animation for the block
				this.animate = (this.$refs.animationWrapper.getBoundingClientRect().top<=(window.innerHeight*.5));
			}
			
			if (direction==='down') {
				if (offsetTop >= (topSwitchOffset - 50) && offsetTop <= (topSwitchOffset + 50)) {
					this.changeBackgroundShade();
				}
				if (offsetTop < (window.innerHeight*.55) && (offsetTopPosition <= 0)) {
					this.active = true;
				} 
			} else {
				offsetTop -= this.$el.clientHeight;
				if (offsetTop >= (topSwitchOffset - 50) && offsetTop <= (topSwitchOffset + 50)) {
					this.changeBackgroundShade();
				}
			}
		},
		changeBackgroundShade() {
			this.$emit('changeBackgroundShade', this.backgroundShade);
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
		window.addEventListener('resize', this.updateHeaderLinkOffset)
		this.updateHeaderLinkOffset()
	},
	destroy() {
		window.removeEventListener('scroll', this.handleScroll)
		window.removeEventListener('resize', this.updateHeaderLinkOffset)
	}
}
</script>